/**
 * Opens the Cookie Settings banner if the CookieScript instance is available.
 *
 * @return {boolean} True if the banner was opened, false otherwise.
 */
function openCookieSettingsBanner() {
  const cookieScriptInstance = window.CookieScript?.instance;

  if ( !cookieScriptInstance || typeof cookieScriptInstance.show !== "function" ) {
    return false;
  }

  cookieScriptInstance.show();
  return true;
}

/**
 * Determines if the given element is a trigger for opening the Cookie Settings banner.
 *
 * @param {Element} element - The element to check.
 * @return {boolean} True if the element is a trigger, false otherwise.
 */
function isCookieSettingsTrigger( element ) {
  if ( !element ) {
    return false;
  }

  if (
    element.id === "csconsentlink" ||
    element.classList.contains( "csconsentlink" ) ||
    element.hasAttribute( "data-cookie-settings" )
  ) {
    return true;
  }

  if ( !element.matches( "a" ) ) {
    return false;
  }

  const href = ( element.getAttribute( "href" ) || "" ).trim().toLowerCase();

  return href === "#cookie-settings" || href.endsWith( "#cookie-settings" );
}

/**
 * Initializes event listeners for elements that trigger the Cookie Settings banner.
 */
export function initCookieSettingsLinks() {
  document.addEventListener( "click", function ( event ) {
    const trigger = event.target.closest(
      "#csconsentlink, .csconsentlink, [data-cookie-settings], a[href]"
    );

    if ( !isCookieSettingsTrigger( trigger ) ) {
      return;
    }

    event.preventDefault();

    if ( openCookieSettingsBanner() ) {
      return;
    }

    window.addEventListener(
      "CookieScriptLoaded",
      function () {
        openCookieSettingsBanner();
      },
      { once: true }
    );
  } );
}
